import {AttributeType, InputType} from "./constants";
import { InputApiConstants } from "./model";

const InputFieldConstants = {
  JobProfile: "job_profile",
  POH: "primary_organizational_home",
  Department: "department",
  DepartmentCode: "department_code",
  Accounts: "accounts",
  HomeOffice: "home_office",
  HomeCountry: "home_country",
  WorkingOffice: "working_office",
  WorkingCountry: "working_office_country",
  Projects: "projects",
  Miscellaneous: "miscellaneous"
};

export const InputFields = {
  [InputFieldConstants.JobProfile]: {
    attributeName: InputFieldConstants.JobProfile,
    userAttribute: "jobProfile",
    attributeLabel: "Job Profile",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.JobProfiles },
  },
  [InputFieldConstants.POH]: {
    attributeName: InputFieldConstants.POH,
    attributeLabel: "POH",
    userAttribute: "primaryOrganizationalHome",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.POHs },
  },
  [InputFieldConstants.Department]: {
    attributeName: InputFieldConstants.Department,
    attributeLabel: "Department",
    userAttribute: "department",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.DepartmentCode,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Departments, key: "name" },
  },
  [InputFieldConstants.DepartmentCode]: {
    attributeName: InputFieldConstants.DepartmentCode,
    attributeLabel: "Department Code",
    userAttribute: "departmentCode",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.Department,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Departments, key: "code" },
  },
  [InputFieldConstants.Accounts]: {
    attributeName: InputFieldConstants.Accounts,
    attributeLabel: "Accounts",
    userAttribute: "accounts",
    inputType: InputType.MultiValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: false,
  },
  [InputFieldConstants.HomeOffice]: {
    attributeName: InputFieldConstants.HomeOffice,
    attributeLabel: "Home Office",
    userAttribute: "homeOffice",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.HomeCountry,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Offices, key: "offices" },
  },
  [InputFieldConstants.HomeCountry]: {
    attributeName: InputFieldConstants.HomeCountry,
    attributeLabel: "Home Country",
    userAttribute: "homeCountry",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.HomeOffice,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Offices, key: "countryCode" },
  },
  [InputFieldConstants.WorkingOffice]: {
    attributeName: InputFieldConstants.WorkingOffice,
    attributeLabel: "Working Office",
    userAttribute: "workingOffice",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.WorkingCountry,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Offices, key: "offices" },
  },
  [InputFieldConstants.WorkingCountry]: {
    attributeName: InputFieldConstants.WorkingCountry,
    attributeLabel: "Working Country",
    userAttribute: "workingOfficeCountry",
    inputType: InputType.SingleValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    relatedTo: InputFieldConstants.WorkingOffice,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Offices, key: "countryCode" },
  },
  [InputFieldConstants.Projects]: {
    attributeName: InputFieldConstants.Projects,
    attributeLabel: "Projects",
    userAttribute: "projects",
    inputType: InputType.MultiValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: false,
  },
  [InputFieldConstants.Miscellaneous]: {
    attributeName: InputFieldConstants.Miscellaneous,
    attributeLabel: "Miscellaneous",
    userAttribute: "miscellaneous",
    inputType: InputType.MultiValuedFieldInBackend.name,
    attributeType: AttributeType.user,
    isEnabled: true,
    inputOptionsAttribute: { mainAttribute: InputApiConstants.Miscellaneous },
    isDisabledForSelectByName: true
  },
};
